import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatCheckboxChange, MatDialogRef} from '@angular/material';
import {AuthService} from '../../services/auth.service';

@Component({
    selector: 'app-choose-table-columns',
    templateUrl: './change-columns.component.html',
    styleUrls: ['./change-columns.component.css']
})
export class ChangeColumnsComponent implements OnInit {

    public intermediate;
    public checked;

    constructor(
        public dialogRef: MatDialogRef<ChangeColumnsComponent>,
        @Inject(MAT_DIALOG_DATA) public columns: Array<any>,
        private authService: AuthService) {
    }

    ngOnInit() {
        this.onColumnChange();

        if (this.authService.isTestUser === undefined) {
            this.authService.isTestingUser().subscribe(isTestUser => {
                if (!isTestUser) {
                    this.removeDevColumns();
                }
            });
        } else if (!this.authService.isTestUser) {
            this.removeDevColumns();
        }
    }

    onCancelClick() {
        this.dialogRef.close(undefined);
    }

    onSaveClick() {
        this.dialogRef.close(this.columns);
    }

    onColumnChange() {
        const visibleColumns = this.columns.filter(column => column['visible']);

        if (visibleColumns.length === this.columns.length) {
            this.intermediate = false;
            this.checked = true;
        } else if (visibleColumns.length > 0) {
            this.intermediate = true;
            this.checked = false;
        } else {
            this.intermediate = false;
            this.checked = false;
        }
    }

    onMasterSelectChange($event: MatCheckboxChange) {
        this.columns.forEach(column => column['visible'] = $event['checked']);
    }

    private removeDevColumns() {
        const skuId = this.columns.find(col => col === 'SKU_id');
        if (skuId) {
            this.columns.splice(this.columns.indexOf(skuId), 1);
        }

        const locProductCd = this.columns.find(col => col === 'Loc_Product_cd');
        if (locProductCd) {
            this.columns.splice(this.columns.indexOf(locProductCd), 1);
        }
    }
}
